<template>
  <div class="container">
    <div class="title">Comments</div>
    <div class="empty" v-if="comments.length === 0">
      No Comment.
    </div>
    <div class="comment" v-for="item in comments" :key="item.id">
      <div class="info">
        <div :style="`background-image: url(${item.from.avatar});`" class="avatar" />
        <div class="right">
          <div class="name">{{item.from.name}}</div>
          <div class="date">{{item.publish_time}}</div>
        </div>
      </div>
      <div class="content">{{item.content}}</div>
      <div class="control">
        <span class="comment-reply" @click="showReplyInput(item)">
          <i class="iconfont el-icon-s-comment"></i>
          <span>Reply</span>
        </span>
      </div>
      <div v-if="item.replies" class="reply">
        <div class="item" v-for="reply in item.replies" :key="reply.id">
          <div class="reply-content-container">
            <span class="from-name">{{reply.from.name}}</span>
            <span>:</span>
            <span class="to-name" v-if="reply.to">@{{reply.to.name}}</span>
            <span class="content">{{reply.content}}</span>
          </div>
          <div class="reply-bottom">
            <span>{{reply.publish_time}}</span>
            <span class="reply-text" @click="showReplyInput(item, reply)">
              <i class="iconfont el-icon-s-comment"></i>
              <span>Reply</span>
            </span>
          </div>
        </div>
        <div class="write-reply" v-if="item.replies.length > 0" @click="showReplyInput(item)">
          <i class="el-icon-edit"></i>
          <span class="add-comment">Add new Reply...</span>
        </div>
        <transition name="fade">
          <div class="input-wrapper" v-if="showItemId === item.id">
            <el-input
              class="gray-bg-input"
              v-model="inputReply"
              type="textarea"
              :rows="3"
              autofocus
              placeholder="Write down your replies here..."
            ></el-input>
            <div class="btn-control">
              <el-button type="text" class="cancel" @click="cancel">Cancel</el-button>
              <el-button type="primary" round @click="commitReply">Commit</el-button>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import { postReply } from "@/api";

export default {
  name: "CommentList",
  props: {
    comments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      inputReply: "",
      showItemId: "",
      replyToId: ""
    };
  },
  methods: {
    commitReply() {
      let content = this.inputReply;
      let replyToId = this.replyToId;
      if (/^@\S+\s/.test(content)) {
        content = content.match(/^@\S+\s(.*)/)[1];
      } else {
        this.replyToId = "";
        replyToId = null;
      }
      postReply(
        content,
        this.$store.state.userId,
        this.showItemId,
        replyToId
      ).then(res => {
        if (res && res.id) {
          this.$message({
            type: "suceess",
            message: "Comment Committed!"
          });
          this.$emit("refresh-comments");
        }
      });
    },
    cancel() {
      this.showItemId = "";
    },
    showReplyInput(item, reply) {
      if (reply) {
        this.inputReply = "@" + reply.from.name + " ";
        this.replyToId = reply.id;
      } else {
        this.inputReply = "";
        this.replyToId = "";
      }
      this.showItemId = item.id;
    }
  }
};
</script>

<style scoped lang="scss">
$color-main: #409eff;

$text-main: #303133;
$text-normal: #606266;
$text-minor: #909399;
$text-333: #333;

$border: #dcdfe6;

.iconfont {
  font-size: 16px;
  margin-right: 5px;
}
.title {
  color: $text-main;
  font-size: 20px;
  margin-bottom: 24px;
}
.container {
  box-sizing: border-box;
  .empty {
    color: $text-minor;
    text-align: center;
    font-size: 24px;
    border-radius: 16px;
    border: 1px dashed;
    padding: 24px;
    margin-bottom: 24px;
  }
  .comment {
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-bottom: 1px solid $border;
    .info {
      display: flex;
      align-items: center;
      .avatar {
        width: 32px;
        height: 32px;
        background-position: center 10%;
        background-size: cover;
        border: 1px rgba(0, 0, 0, 0.25) solid;
        border-radius: 50%;
        overflow: hidden;
      }
      .right {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        .name {
          font-size: 16px;
          color: $text-main;
          margin-bottom: 5px;
          font-weight: 500;
        }
        .date {
          font-size: 12px;
          color: $text-minor;
        }
      }
    }
    .content {
      font-size: 16px;
      color: $text-main;
      line-height: 20px;
      padding: 10px 0;
    }
    .control {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: $text-minor;
      .comment-reply {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
          color: $text-333;
        }
      }
    }
    .reply {
      margin: 10px 0;
      border-left: 2px solid $border;
      .item {
        margin: 0 10px;
        padding: 10px 0;
        border-bottom: 1px dashed $border;
        .reply-content-container {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: $text-main;
          .from-name {
            color: $color-main;
          }
          .to-name {
            color: $color-main;
            margin-left: 8px;
          }
          .content {
            margin-left: 8px;
          }
        }
        .reply-bottom {
          display: flex;
          align-items: center;
          margin-top: 6px;
          font-size: 12px;
          color: $text-minor;
          .reply-text {
            display: flex;
            align-items: center;
            margin-left: 10px;
            cursor: pointer;
            &:hover {
              color: $text-333;
            }
            .icon-comment {
              margin-right: 5px;
            }
          }
        }
      }
      .write-reply {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: $text-minor;
        padding: 10px;
        cursor: pointer;
        &:hover {
          color: $text-main;
        }
        .el-icon-edit {
          margin-right: 5px;
        }
      }
      .fade-enter-active,
      fade-leave-active {
        transition: opacity 0.5s;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
    }
  }
  .input-wrapper {
    padding: 10px;
    .btn-control {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-top: 10px;
      .cancel {
        font-size: 16px;
        color: $text-normal;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          color: $text-333;
        }
      }
      .confirm {
        font-size: 16px;
      }
    }
  }
}
</style>